<template>
  <div class="header-box">
      <div class="header-container">
        <div class="header-left">
          <router-link tag="h1" :to="{path:'/index/home'}"><span>美国大运河</span>Grand Channel Inc</router-link>
        </div>
        <div class="header-right">
            <p>Customer Service: 909-443-5876</p>
            <div class="header-nav">
                <ul>
                  <li :class="isactive('home')">
                    <router-link tag="span" :to="{path:'/index/home'}">Home</router-link>
                  </li>
                  <li :class="isactive('service')">
                    <router-link tag="span" :to="{path:'/index/service'}">Service</router-link>
                    <ul class="service-nav">
                      <router-link tag="li" :to="{path:'/index/service',query:{url:'forwarding'}}"><span>FBA Forwarding</span></router-link>
                      <router-link tag="li" :to="{path:'/index/service',query:{url:'shipping'}}"><span>Drop Shipping</span></router-link>
                      <router-link tag="li" :to="{path:'/index/service',query:{url:''}}"><span>Custom Solutions</span></router-link>
                    </ul>
                  </li>
                  <li :class="isactive('about')">
                    <router-link tag="span" :to="{path:'/index/about'}">About</router-link>
                  </li>
                  <li :class="isactive('contact')">
                    <a href="http://www.grandchannel.net" target="_blank"><span>Log In</span></a>
                  </li>
                </ul>
                <span>简体中文</span>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'headernav',
    data () {
      return {

      }
    },
    methods:{
      isactive(url){
        let active='';
        let path=this.$route.path;
        if(path.indexOf(url)>-1){
          active="active";
        }
        return active;
      }
    },
    computed:{

    },
    mounted(){

    },
    watch:{
      // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .header-box {
    width:100%;
    height: 80px;
    background-color: rgba(250, 250, 250, 0.7);
    position:absolute;
    top: 0;
    left:0;
    z-index:10000;

    .header-container {
      width:1200px;
      height: 100%;
      margin:auto;

      .header-left {
        width:200px;
        float:left;
        height:100%;

        h1 {
          text-indent: -9999px;
          width:200px;
          height:100%;
          cursor:pointer;
          background: url('../../assets/images/logo.png') no-repeat center;
          span {
            width:0;
            height:0;
            overflow: hidden;
          }
        }
      }
      .header-right {
        float:right;
        height:100%;

        >p {
          height:50%;
          line-height: 40px;
          font-size: 16px;
          text-align:right;
        }
        .header-nav {
          height:50%;
          position:relative;
          width:1000px;
          >ul{
            display: block;
            position:absolute;
            top: 0;
            right:200px;
            >li{
              float:left;
              height:40px;
              line-height:40px;
              width:160px;
              cursor: pointer;
              text-align:center;
              position:relative;
              &:hover {
                background-color:rgba(250,250,250,0.8);
                .service-nav {
                  display:block;
                }
              }
              &.active {
                background-color:rgba(250,250,250,0.8);
              }
              span {
                font-size:18px;
                display:block;
                width:100%;
                height:100%;
                user-select:none;
              }
              .service-nav {
                position:absolute;
                top: 40px;
                left: 0;
                display:none;
                >li {
                  display:block;
                  width:160px;
                  height:40px;
                  line-height:40px;
                  background:#fff;
                  span {
                    font-size:16px;
                    color:#333;
                  }
                  &:hover {
                    span {
                      color:blue;
                    }
                  }
                }
              }
            }
          }
          >span {
            display:block;
            height:40px;
            line-height:40px;
            width:160px;
            float:right;
            text-align:right;
            font-size:18px;
            background:url('../../assets/images/lang.png') no-repeat 62px center;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/header/header.vue